import { useEffect, useState } from "react";
import getcdnBaseURL from "./getcdnurl";

const GetimageBaseURL = () => {
  const [imgUrl, setImgUrl] = useState<any>();
  useEffect(() => {
    getcdnBaseURL().then((response) => setImgUrl(response?.containerCDNURL));
  }, []);
  return imgUrl;
};

let commonUrl = "images/techrefresh/";
let commonUrlNotification = "images/techrefresh/Notifications/";

export const komatsu = commonUrl + "komatsu.jpg";
export const registration = commonUrl + "registrationbackground.jpg";
export const facebooksvg = commonUrl + "facebook.svg";
export const twitter = commonUrl + "twitter.svg";
export const linkedinsvg = commonUrl + "linkedin.svg";
export const instagramsvg = commonUrl + "instagram.svg";
export const youtube = commonUrl + "youtube.svg";
export const usersvg = commonUrl + "user.svg";
export const komatsuname = commonUrl + "MyKomatsuText.svg";
export const komatsuMainLogo = commonUrl + "KomatsuMainLogo.svg";
export const komatsuMainLogoFooter = commonUrl + "komatsuMainLogoFooter.svg";
export const commingsoonImg = commonUrl + "CommingSoon1.png";
export const close = commonUrl + "close.png";
export const bg404 = commonUrl + "bg_404.png";
export const CloseIcon = commonUrl + "Close-White.svg";
export const arrowDownicon = commonUrl + "arrowDownicon.png";
export const machinesvg = commonUrl + "machine.svg";
export const iconday = commonUrl + "Day-Blue.svg";
export const icondayActive = commonUrl + "Day-White.svg";
export const iconmonth = commonUrl + "Month-Blue.svg";
export const iconmonthActive = commonUrl + "Month-White.svg";
export const iconweekActive = commonUrl + "Week-White.svg";
export const iconwek = commonUrl + "Week-Blue.svg";
export const iconCustom = commonUrl + "Custom.svg";
export const iconCustomActive = commonUrl + "Custom-White.svg";
export const iconsearch = commonUrl + "Icon_Search.png";
export const quickLinkLocation = commonUrl + "quickLinkLocation.svg";
export const book = commonUrl + "book.svg";
export const external = commonUrl + "external.svg";
export const RecomendedIconsvg = commonUrl + "RecomendedIcon.svg";
export const RecomendedMaintenanceIcon = commonUrl + "PartsRecommended.png";
export const locatemapIconsvg = commonUrl + "locatemapIcon.svg";
export const kowaIconsvg = commonUrl + "KOWA.png";
export const kowaIcon = commonUrl + "KOWA_List.png";
export const ManualIconsvg = commonUrl + "ManualIcon.svg";
export const partsBookIcon = commonUrl + "partsBookIcon.svg";
export const TowerGreen = commonUrl + "TowerGreen.svg";
export const TowerRed = commonUrl + "TowerRed.svg";
export const settings = commonUrl + "partsBookIcon.svg";
export const Vehicle = commonUrl + "Vehicle.png";
export const Global = commonUrl + "Global.png";
export const marker = commonUrl + "Map/Normal/blue/marker/m1.png";
export const PartsImage = commonUrl + "PartsImage.svg";
export const fleetnoimage = commonUrl + "fleetnoimage.png";
export const alert = commonUrl + "alert.jpg";
export const msgjpg = commonUrl + "msg.jpg";
export const XLsvg = commonUrl + "XL.svg";
export const Clearsvg = commonUrl + "Clear.svg";
export const searchWhitesvg = commonUrl + "Search.svg";
export const Truck = commonUrl + "Truck.png";
export const Tick = commonUrl + "Tick.png";
export const Plus = commonUrl + "Plus.png";
export const ErrorImg = commonUrl + "error.svg";
export const Other = commonUrl + "ISO/Big/OTHER.png";
export const loadermarker = commonUrl + "loader.png";
export const ExpandGrey = commonUrl + "Expand-Grey.svg";
export const ExpandBlue = commonUrl + "Expand-Blue.svg";
export const xlactive = commonUrl + "ExcelBlue.svg";
export const MaintenanceBlue = commonUrl + "MaintenanceBlue.svg";
export const MaintenanceRecomBlue = commonUrl + "MaintenanceRecomBlue.svg";
export const pdfactive = commonUrl + "PDFBlue.svg";
export const tableinactive = commonUrl + "Table-Blue.svg";
export const tableactive = commonUrl + "Table-White.svg";
export const graphinactive = commonUrl + "Chart-Blue.svg";
export const graphactive = commonUrl + "Chart-White.svg";
export const IMC2 = commonUrl + "IMC2.png";
export const exporticon = commonUrl + "Export.png";
export const loactionwhite = commonUrl + "loactionwhite.png";
export const ChartViewBlue = commonUrl + "ChartViewBlue.svg";
export const ChartViewWhite = commonUrl + "ChartViewWhite.svg";
export const listactive = commonUrl + "ListviewBlue.svg";
export const listinactive = commonUrl + "ListviewWhite.svg";
export const downloadWhite = commonUrl + "DownloadWhite.svg";
export const compareView = commonUrl + "CompareToFleet.svg";
export const contantactBlue = commonUrl + "Contacts-Blue.svg";
export const contantactWhite = commonUrl + "Contacts-White.svg";
export const Report = commonUrl + "Report.svg";
export const QuickRefGuide = commonUrl + "Quick-Ref-Guide.svg";
export const PartsList = commonUrl + "Parts-List.svg";
export const PartsBook = commonUrl + "PartsBook.svg";
export const Location = commonUrl + "Location.svg";
export const Notes = commonUrl + "Notes.svg";
export const OrderHistoryBlue = commonUrl + "OrderHistory-Blue.svg";
export const OrderHistoryWhite = commonUrl + "OrderHistory-White.svg";
export const DownloadWhite = commonUrl + "Download-White.svg";
export const EmailWhite = commonUrl + "Email-White.svg";
export const PromotionWhite = commonUrl + "Promotion-White.svg";

export const DistributorView = commonUrl + "DistributorView.svg";
export const CustomerView = commonUrl + "CustomerView.svg";
export const MyfleetGraphIcon = commonUrl + "MyFleet/Graph.svg";
export const Sync = commonUrl + "MyFleet/Sync.svg";
export const downloadBlue = commonUrl + "DownloadBlue.svg";
export const RequestQuote = commonUrl + "RequestQuote.svg";
export const coverageBadge = commonUrl + "CoverageBadge.svg";
export const ShareWhite = commonUrl + "ShareWhite.svg";
export const Share = commonUrl + "Share.svg";
export const fleetSetting = commonUrl + "SettingsWhite.svg";
/* My Alerts */

export const ManualIconWhite = commonUrl + "ManualIconWhite.svg";
export const partsBookIconWhite = commonUrl + "partsBookIconWhite.svg";

export const NotificationAlert = commonUrl + "Alerts/Notification.png";

export const Recom_Abnormalities =
  commonUrl + "Alerts/RecommendedAlert/Abnormalities.svg";
export const Recom_FactoryCampaignAlert =
  commonUrl + "Alerts/RecommendedAlert/FactoryCampaignAlert.svg";
export const Recom_KCPCoverage =
  commonUrl + "Alerts/RecommendedAlert/KCPCoverage.svg";
export const Recom_MaintenanceAlert =
  commonUrl + "Alerts/RecommendedAlert/MaintenanceAlert.svg";
export const Freq_CautionAlert =
  commonUrl + "Alerts/FrequentlyUsedAlerts/CautionAlert.svg";
export const Freq_ComponentTracking =
  commonUrl + "Alerts/FrequentlyUsedAlerts/ComponentTracking.svg";
export const Freq_KOWAAlerts =
  commonUrl + "Alerts/FrequentlyUsedAlerts/KOWAAlerts.svg";
export const Freq_MovementAlerts =
  commonUrl + "Alerts/FrequentlyUsedAlerts/MovementAlerts.svg";
export const MaintenanceRecommendation =
  commonUrl + "Maintenance-Recommnedation.svg";
export const addtocart = commonUrl + "addtocart.png";
export const booksvg = commonUrl + "book.svg";
export const compare = commonUrl + "compare.png";
export const dozer = commonUrl + "DOZER.png";
export const droplet = commonUrl + "droplet.png";
export const editpensvg = commonUrl + "editpen.svg";
export const engineoilscg = commonUrl + "engineoil.svg";
export const engineoilfiltersvg = commonUrl + "engineoilfilter.svg";
export const eyeicon = commonUrl + "eyeicon.svg";
export const filtericonhover = commonUrl + "filter_icon_hover.png";
export const filter_icon = commonUrl + "filter_icon.png";
export const fuelfreefilter = commonUrl + "fuelfreefilter.svg";
export const globe = commonUrl + "globe.png";
export const iconabnormalitiessvg = commonUrl + "Icon_Abnormalities.svg";
export const iconsetting01svg = commonUrl + "Icon_Setting_01.svg";
export const iconsetting = commonUrl + "Icon_Setting.svg";
export const imgtypesvg = commonUrl + "Img_Type.svg";
export const ImgWorld = commonUrl + "Img_World.svg";
export const KOWAReportsvg = commonUrl + "KOWAReport.svg";
export const leftarrowsvg = commonUrl + "leftarrow.svg";
export const leftarrow1svg = commonUrl + "LeftArrow1.svg";
export const leftarrowBluesvg = commonUrl + "leftarrowBlue.svg";
export const list = commonUrl + "list.png";
export const machineDetailsvg = commonUrl + "MachineDetail.svg";
export const machineDetailpng = commonUrl + "MachineDetails.png";
export const machineDetailHoversvg = commonUrl + "MachineDetailHover.svg";
export const machineLocationsvg = commonUrl + "machineLocation.svg";
export const maintennaceDuesvg = commonUrl + "maintennaceDue.svg";
export const ManualIcon = commonUrl + "list.svg";
export const MyCoveragehover = commonUrl + "MyCoveragehover.svg";
export const MyCoverageimg = commonUrl + "MyCoverage.svg";
export const MyFinance = commonUrl + "MyFinance.svg";
export const MyFinanceHover = commonUrl + "MyFinanceHover.svg";
export const MyHealths = commonUrl + "MyHealth.svg";
export const MyHealthHover = commonUrl + "MyHealthHover.svg";
export const MyLocation = commonUrl + "MyLocation.svg";
export const MyLocationHover = commonUrl + "MyLocationHover.svg";
export const MyTire = commonUrl + "MyTire.svg";
export const MyTireHover = commonUrl + "MyTireHover.svg";
export const MyUtilizationHover = commonUrl + "MyUtilizationHover.svg";
export const parts = commonUrl + "parts.svg";
export const PromotionNew = commonUrl + "PromotionNew.jpg";
export const Promotionsoldthumb = commonUrl + "Promotions-old-thumb.jpg";
export const Promotions1thumb = commonUrl + "Promotions1-thumb.png";
export const Promotions2large = commonUrl + "Promotions2-large.png";
export const Promotions2thumb = commonUrl + "Promotions2-thumb.png";
export const Promotions3large = commonUrl + "Promotions3-large.png";
export const Promotions3thumb = commonUrl + "Promotions3-thumb.png";
export const Promotions4thumb = commonUrl + "Promotions4-thumb.png";
export const quickReference = commonUrl + "quickReference.svg";
export const reapairTools = commonUrl + "reapairTools.svg";
export const Reporting = commonUrl + "Reporting.svg";
export const ReportingHover = commonUrl + "ReportingHover.svg";
export const requestQuota = commonUrl + "requestQuota.svg";
export const rightarrow = commonUrl + "rightarrow.svg";
export const RightArrow1 = commonUrl + "RightArrow1.svg";
export const rightarrowBlue = commonUrl + "rightarrowBlue.svg";
export const search = commonUrl + "search.png";
export const signup = commonUrl + "signup.png";
export const tag = commonUrl + "tag.png";
export const tagsvg = commonUrl + "tag.svg";
export const tireIcon = commonUrl + "tireIcon.svg";
export const user = commonUrl + "user.png";
export const Utilization = commonUrl + "Utilization.svg";
export const MyProductivityDark = commonUrl + "MyProductivityDark.svg";
export const calendar = commonUrl + "Calendar-White.svg";
export const filter = commonUrl + "Filter.svg";
export const vechileimg = commonUrl + "Image.png";
export const logoWhite = commonUrl + "Logo_white.png";
export const Carelogo = commonUrl + "Care_logo.png";
export const coin = commonUrl + "coin.png";
export const addicon = commonUrl + "Plus-Blue.svg";
export const editpen_White = commonUrl + "editpen_White.svg";
export const save_White = commonUrl + "Save.svg";
export const close_White = commonUrl + "CloseWhite.svg";
export const ReportingDark = commonUrl + "ReportingDark.svg";
export const MyiMCDark = commonUrl + "MyiMCDark.svg";
export const MyiMC = commonUrl + "IMC.svg";
export const MyTrendsDark = commonUrl + "MyTrendsDark.svg";
export const saveIcon = commonUrl + "Save.png";
export const quickReferGuide = commonUrl + "quickRefernceGuide.png";
export const linkdropdown = commonUrl + "LinksDropdown.svg";
export const CloseBlue = commonUrl + "CloseBlue.svg";
export const partList = commonUrl + "partslist.png";
export const note = commonUrl + "notes.png";
export const QuestionMark = commonUrl + "questionmark.png";
export const edit = commonUrl + "Editsvg.svg";
export const bgblueround = commonUrl + "bg-round_blue.png";
export const ManageOtherOEM = commonUrl + "ManageOtherOEM.svg";
export const calenderIcon = commonUrl + "Calendar.png";
export const calendarBlue = commonUrl + "Calendar-Blue.svg";

export const sms = commonUrl + "Alert Configuration/SMS.png";
export const email = commonUrl + "Alert Configuration/Email.png";
export const mobileapp = commonUrl + "Alert Configuration/MobileApp.png";
export const webapp = commonUrl + "Alert Configuration/WebApp.png";
export const downicon = commonUrl + "arrowDownicon.png";
export const factoryCamping = commonUrlNotification + "FactoryCampaign.png";
export const Abnormality = commonUrlNotification + "Abnormality.png";
export const Caution = commonUrlNotification + "FactoryCampaign.png";
export const tracking = commonUrlNotification + "ComponentTracking.png";
export const engineehour = commonUrlNotification + "EngineHours.png";
export const fuelconsumption = commonUrlNotification + "FuelConsumption.png";
export const idlehours = commonUrlNotification + "Idlehours.png";
export const territory = commonUrlNotification + "Territory.png";
export const tasklist = commonUrlNotification + "Task List.png";
export const scheduleAlert = commonUrlNotification + "Schedule Alert.png";
export const regeneration = commonUrlNotification + "Regeneration.png";
export const movements = commonUrlNotification + "Movement.png";
export const trends = commonUrlNotification + "Trends.png";
export const maintenace = commonUrlNotification + "Maintenance.png";
export const kowa = commonUrlNotification + "KOWA.png";
export const kcpcoverage = commonUrlNotification + "KCPCoverage.png";
export const quotes = commonUrlNotification + "Quotes.svg";
export const tick = commonUrl + "tick.png";
export const gsa = commonUrlNotification + "GlobalSafetyAlert.svg";
export const gsn = commonUrlNotification + "GlobalSafetyNotice.svg";

export const alertAbnormalities =
  commonUrl + "Alerts/myalerts/Abnormalities.svg";
export const alertCaution = commonUrl + "Alerts/myalerts/Caution.svg";
export const alertComponentTracking =
  commonUrl + "Alerts/myalerts/ComponentTracking.svg";
export const alertExcessiveEngineonHours =
  commonUrl + "Alerts/myalerts/ExcessiveEngineonHours.svg";
export const alertExcessiveIdleTime =
  commonUrl + "Alerts/myalerts/ExcessiveIdleTime.svg";
export const alertExcessiveRegeneration =
  commonUrl + "Alerts/myalerts/ExcessiveRegeneration.svg";
export const alertFactoryCampaignEmission =
  commonUrl + "Alerts/myalerts/FactoryCampaignEmission.svg";
export const alertFuelConsumption =
  commonUrl + "Alerts/myalerts/FuelConsumption.svg";
export const alertKCPCoverage = commonUrl + "Alerts/myalerts/KCPCoverage.svg";
export const alertKOWA = commonUrl + "Alerts/myalerts/KOWA.svg";
export const alertMaintenanceDue =
  commonUrl + "Alerts/myalerts/MaintenanceDue.svg";
export const alertMovement = commonUrl + "Alerts/myalerts/Movement.svg";
export const alertQuotes = commonUrl + "Alerts/myalerts/Quotes.svg";
export const alertTaskList = commonUrl + "Alerts/myalerts/TaskList.svg";
export const alertTerritory = commonUrl + "Alerts/myalerts/Territory.svg";
export const alertTrendAlerts = commonUrl + "Alerts/myalerts/TrendAlerts.svg";

export const LocationDropdownImage = commonUrl + "Main_Location_Yellow.svg";
export const flagmyproductivity = commonUrl + "flag-myproductivity.jpg";

export const markerIconForAT = commonUrl + "Map/Normal/blue/AT.png";
export const markerClusterImageUrlAbnormalities =
  commonUrl + "ClusterMarker/Abnormalities/m";
export const markerClusterImageUrlCautions =
  commonUrl + "ClusterMarker/Cautions/m";
export const markerClusterImageUrlFactoryCampaigns =
  commonUrl + "ClusterMarker/FactoryCampaigns/m";
export const markerClusterImageUrlFleetHours =
  commonUrl + "ClusterMarker/FleetHours/m";
export const markerClusterImageUrlMaintenanceView =
  commonUrl + "ClusterMarker/MaintenanceView/m";
export const markerClusterImageUrlMovements =
  commonUrl + "ClusterMarker/Movements/m";
export const markerClusterImageUrlNoCommunication =
  commonUrl + "ClusterMarker/NoCommunication/m";
export const markerClusterImageUrlNoUsage =
  commonUrl + "ClusterMarker/NoUsage/m";
export const markerClusterImageUrlComponentTracking = commonUrl + "ClusterMarker/ComponentTracking/m";

export const MordernMachine = commonUrl + "MordernMachine.png";
export const Usericon = commonUrl + "Usericon.svg";
export const Telephone = commonUrl + "Telephone.svg";
export const Phone = commonUrl + "Phone.svg";
export const Mail = commonUrl + "Mail.svg";
export const ReportingBlue = commonUrl + "Report-Blue.svg";

export const DistributorBranch = commonUrl + "DistributorBranch.svg";
export const NoImage = commonUrl + "NoImage.png";
export const kowaNormalStatus = commonUrl + "Normal.svg";
export const kowaAbnormalStatus = commonUrl + "Abnormal.svg";
export const kowaCriticalStatus = commonUrl + "critical.png";
export const kowaElevatedStatus = commonUrl + "monitor.png";
export const kowaReportView = commonUrl + "Kowa_view.png";
export const kowaReport = commonUrl + "logo-kowa.png";
export const kowaFluid = commonUrl + "FluidLife.png";

export const signout = commonUrl + "Signout_blue.svg";
export const DistributorContacts = commonUrl + "Distributor-Contacts.svg";
export const KACView = commonUrl + "KACView.svg";
export const ProfileBlue = commonUrl + "Profile-Blue.svg";
export const TestAccount = commonUrl + "Test-Account.svg";
export const info = commonUrl + "info.svg";
export const mykBranding = commonUrl + "MyKomatsubranding.png";
export const mykClearIcon = commonUrl + "Clear.svg";
export const customToggleIcon = commonUrl + "customToggle.jpg";
export const cptTemplateUrl =
  commonUrl + "ComponentTrackingTemplate/ComponentUploadTemplate.xlsx";
export const uploadBlue = commonUrl + "Upload-Blue.svg";
export const penIconBlue = commonUrl + "Edit-Blue.svg";
export const AddBlue = commonUrl + "Create-Alert.svg";
export const downArrowBlue = commonUrl + "Downarrow-Blue.svg";
export const ScheduleAlertsN = commonUrl + "ScheduleAlert.png";
export const eraser = commonUrl + "eraser.svg";

export const bell = commonUrl + "Bell.svg";
export const support = commonUrl + "Supportcopy.svg";
export const clear = commonUrl + "clearBtn.svg";
export const searchsvg = commonUrl + "Search.svg";
export const cart = commonUrl + "Cart.svg";

export const imagenotloaded = commonUrl + "image-not-loaded.jpg";
export const greenClose = commonUrl + "greenClose.svg";
export const otExcelExport = commonUrl + "otExcelExport.svg";
export const otFilter = commonUrl + "otFilter.svg";
export const otFilter14 = commonUrl + "otFilter14.svg";
export const otSearchblue = commonUrl + "otSearchblue.svg";
export const Quote = commonUrl + "Quote.svg";
export const AddParts = commonUrl + "AddParts.svg";
export const SavePartList = commonUrl + "SavedPartsList.svg";
export const OrderTracking = commonUrl + "OrderTracking.svg";
export const InitiateReturn = commonUrl + "InitiateReturn.svg";

export default GetimageBaseURL;

export const HomeBanner1 = commonUrl + "banner-3.png";
export const HomeBanner2 = commonUrl + "Banner Devices.png";
export const HomeBanner3 = commonUrl + "Banner FleetMngmt.png";
export const HomeBanner4 =
  commonUrl + "My-Komatsu-banners-1920x666px-(June-2023)Rev1.jpg";
export const locator = commonUrl + "locator.svg";

export const mininglistactive = commonUrl + "mininglistview-blue.svg";
export const mininglistinactive = commonUrl + "mininglistview.svg";
export const miningchartviewactive = commonUrl + "miningchartview-blue.svg";
export const miningchartinactive = commonUrl + "miningchartview.svg";
export const miningdragicon = commonUrl + "miningdragIcon.svg";
export const miningexpandIcon = commonUrl + "MiningexpandIcon.svg";
export const miningcontextIcon = commonUrl + "MiningcontextIcon.svg";
export const CollapseMining = commonUrl + "CollapseMining.svg";
export const RedirectWhiteMining = commonUrl + "RedirectWhiteMining.svg";
export const specsheetsMining = commonUrl + "specsheetsMining.svg";
export const gridActiveMining = commonUrl + "BlueTableMining.svg";
export const gridInActiveMining = commonUrl + "WhiteTableMining.svg";

export const InfoMining = commonUrl + 'InfoMining.svg'
export const send = commonUrl + "send.png"
export const instagram = commonUrl + "instagram.png"

export const tableCustomize = commonUrl + 'tableCustomize.svg'
export const tableCustomizeWhite = commonUrl + "tableCustomizeWhiite.svg"
export const DragDrop = commonUrl + "DragDrop.svg"